import React, { Component } from 'react';
import { Form, Button, Dimmer, Loader } from 'semantic-ui-react'
import './Calendar.css';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { connect } from 'react-redux';
import { Calendar, NextIcon } from 'react-calendar';
import ReactDOM from 'react-dom'
import { authAxios } from '../utils';
import { GetEmployeeInformationURL, GetInvalidWeekURL, InsertPatchEmployeeAsyncURL } from '../constants';
import { authContext } from '../adalConfig';
import alert from '../img/Alert.PNG';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import enUS from 'date-fns/locale/en-US';
import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';
import ProHeader from './Pro/ProHeader';
import ProFooter from './Pro/ProFooter';
import RHHeader from './Corp/RHHeader';
import RHFooter from './Corp/RHFooter';
import RHHeaderField from './Field/RHHeaderField';
import RHFooterField from './Field/RHFooterField';
import { translationsV2 } from '../translations';

let loginNameWithDomain = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
class CalendarComp extends Component {
    constructor(props) {
        super();
        window.calcomp = this;
        this.handleGoToHelp = this.handleGoToHelp.bind(this);
        this.handleCalClickBack = this.handleCalClickBack.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handleDateSelected = this.handleDateSelected.bind(this);
        this.state = {
            selectedDay: null,
            invalidDates: [],
            disabledDates: null,
            userRole: null,
            loading: false,
            error: false,
            key: '',
            country: null,
            region: '',
            translations: {
            },
        };
    }

    handleDayClick(day, modifiers = {}) {
        if (modifiers.disabled) {
            return;
        }
        this.setState({
            selectedDay: modifiers.selected ? undefined : day,
            error: false

        });
    }

    componentDidMount() {
        this.setState({
            loading: true
        })

        let allEnableMondays = [];
        for (let i = 0; i < 8; i++) {
            let monday = (this.DateNow().getDate() + (7 * i));
            allEnableMondays.push(new Date(this.DateNow().setDate(monday)).toLocaleDateString());
        }
        let invalidMondayResponses = []
        if (!loginNameWithDomain) {
            this.props.history.push('./unauthorized');
            return;
        }

        authAxios.post(GetEmployeeInformationURL, {
            LoginNameWithDomain: loginNameWithDomain
        })
            .then(response => {
                let data = response.data;
                let upgradeWeekAppointment = !data.upgradeWeek ? null : new Date(data.upgradeWeek)
                this.setState({
                    selectedDay: upgradeWeekAppointment, userRole: data.userRole, key: data.key, country: data.country, region: data.region
                });

                const country = this.state.country;

                // Load translations based on the country
                let translations = this.getTranslationsBasedOnCountry(country);
                if (translations) {
                    this.setState({
                        translations: translations
                    });
                }


                let LOB = data.region === 'EMEA' && data.userRole === 'CORPORATE' ? 'EMEA CORP' : data.region === 'EMEA' && data.userRole === 'PROTIVITI' ? 'EMEA PRO' : data.region === 'EMEA' && data.userRole === 'FIELD' ? 'EMEA FIELD' : data.region === 'NA' && data.userRole === 'CORPORATE' ? 'CORP' : data.region === 'NA' && data.userRole === 'PROTIVITI' ? 'PRO' : 'FIELD';
                authAxios.post(GetInvalidWeekURL, {
                    upgradeWeeks: allEnableMondays,
                    Country: data.country,
                    LOB: LOB
                })
                    .then(response => {
                        invalidMondayResponses = response.data;
                        let disableDates = [];
                        disableDates.push({ daysOfWeek: [0, 2, 3, 4, 5, 6] });
                        disableDates.push({
                            before: this.DateNow()
                        });
                        disableDates.push({
                            after: this.DateFuture()
                        });
                        invalidMondayResponses.map(_ =>
                            disableDates.push(new Date(_))
                        );
                        this.setState({
                            disabledDates: disableDates,
                            loading: false,
                        })
                        if (invalidMondayResponses.indexOf(data.upgradeWeek) !== -1) { // if employee upgradeWeek exists in invalidMondayResponses
                            this.setState({
                                selectedDay: null
                            })
                        }

                    }).catch((error) => {
                        console.log('error ' + error);
                        this.setState({ exceededMaxSlotDate: true, loading: false });
                    })

            })
            .catch((error) => {
                console.log('error ' + error);
                this.setState({
                    errorredirect: true
                });
                this.setState({
                    loading: false
                })
                this.props.history.push('./unauthorized');
            });
    }

    getTranslationsBasedOnCountry(country) {
        const translations = translationsV2.find(t => t.language === country);
        if (translations) {
            return translations.translations;
        }
        return translationsV2.find(t => t.country === "United States").translations;
    }

    getDateFnsLocale(country) {
        switch (country) {
            case 'DE': return de;
            case 'FR': return fr;
            case 'IT': return it;
            default: return enUS;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedDay } = this.state;
        if (selectedDay !== prevState.selectedDay) {
            this.date = this.state.selectedDay;
            this.setState({
                selectedDay
            })
        }
    }

    //ensureDataFetched() {
    //    const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
    //    this.props.requestWeatherForecasts(startDateIndex);

    //}

    handleGoToHelp() {
        this.props.history.push('./help');
    }

    handleCalClickBack() {
        if (this.state.userRole === 'PROTIVITI')
            this.props.history.push('./selection');
        else if (this.state.userRole === 'CORPORATE')
            this.props.history.push('./selectioncorp');
        else if (this.state.userRole === 'FIELD')
            this.props.history.push('./selectionfield');
    }

    state = {
        date: new Date(),
        selectedDay: "",
        exceededMaxSlotDate: false
    }

    handleNextClick() {
        if (this.state.selectedDay) {

            authAxios.patch(InsertPatchEmployeeAsyncURL + this.state.key,
                [
                    {
                        "op": "replace",
                        "path": "/UpgradeWeek",
                        "value": this.formatDate(this.state.selectedDay)
                    }
                ])
                .then(response => {
                    this.setState({ exceededMaxSlotDate: false });
                    if (this.state.country === 'GB' || this.state.country === 'LU' || this.state.country === 'BE' || this.state.country === 'NL' || this.state.country === 'CH' || this.state.country === 'IE'
                        || this.state.country === 'DE' || this.state.country === 'FR')
                        this.props.history.push('./review');
                    else
                        this.props.history.push('./software');
                })

                .catch((error) => {
                    console.log('error: ' + error);
                });
        }
        else {
            this.setState({
                error: true
            })

        }
        return false;
    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        return [month, day, year].join('/');
    }

    onChange = async function (date) {

        await this.setState({ date: date });
        await this.setState({ selectedDay: this.date });
    }

    DateNow = () => {
        let today = new Date();
        var days = 21;
        let firstMondayOfTheCurrentWeek = today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1) + days;
        return new Date(today.setDate(firstMondayOfTheCurrentWeek));
    }

    DateFuture = () => {
        let today = new Date();
        var days = 70;
        let firstMondayOfTheCurrentWeek = today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1) + days;
        return new Date(today.setDate(firstMondayOfTheCurrentWeek));
    }

    passActiveDate(activeDate) {
        const monthAfterPress = activeDate.getMonth();
        console.log(monthAfterPress);
    }

    formatMonthTitle(d, locale) {
        return `${d.getMonth() + 1}/${d.getFullYear}`
    }

    handleHeaderSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProHeader />;
        else if (this.state.userRole === 'CORPORATE')
            return <RHHeader />;
        else if (this.state.userRole === 'FIELD')
            return <RHHeaderField />;
    }

    handleFooterSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProFooter />;
        else if (this.state.userRole === 'CORPORATE')
            return <RHFooter />;
        else if (this.state.userRole === 'FIELD')
            return <RHFooterField />;
    }

    handleDateSelected() {
        if (this.state.selectedDay) {
            return (
                <React.Fragment>
                    <Form.Field>
                        <label className='selecteddate'>
                            {this.state.translations.calCompMsgSelectedDate}: {new Date(this.state.selectedDay).toLocaleDateString()}
                        </label>
                    </Form.Field>
                </React.Fragment>
            )
        }
    }

    userErrorMessage = () => {
        return (
            <React.Fragment>
                {this.state.error === true &&
                    <h2 className="errorreviewUIselect" >
                        {this.state.translations.calCompMsgSelectDateError}.
                    </h2>

                }

            </React.Fragment>
        )
    }

    handleEAW() {
        if (this.state.country === 'GB' || this.state.country === 'LU' || this.state.country === 'BE' || this.state.country === 'NL' || this.state.country === 'IE'
            || this.state.country === 'CH' || this.state.country === 'DE' || this.state.country === 'FR')
            return (
                <React.Fragment>
                    <h4 className='h4cal'> {this.state.translations.calCompMsgSelect}.</h4>
                    <h4 className='h4cal'> {this.state.translations.calCompMsgReceive}</h4>
                </React.Fragment>
            )
    }

    handleUSw() {
        if (this.state.country === 'US' || this.state.country === 'CA')
            return (
                <React.Fragment>
                    <h4 className='h4cal'> {this.state.translations.calCompMsgSelect}.</h4>
                    <h4 className='h4cal'> {this.state.translations.calCompMsgReceive}.</h4>
                </React.Fragment>
            )
    }

    handelHelpButton() {
        if (this.state.country === 'US') {
            return (
                <React.Fragment>
                    <Button
                        className="calhelpbutton"
                        onClick={this.handleGoToHelp}>
                        {this.state.translations.buttonHelpText}
                    </Button>
                </React.Fragment>
            )
        }
    }

    render() {
        const localeObj = this.getDateFnsLocale(this.state.country);
        if (this.state.loading)
            return (
                <div className="center-me">
                    <Dimmer active inverted>
                        <Loader size='huge'>{this.state.translations.calCompMsgGettingDates}...</Loader>
                    </Dimmer>
                </div>
            )

        const { userRole } = this.state;
        return (

            <div className='outer-container'>
                <div className='inner-container'>
                    {this.handleHeaderSelection()}



                    <h1 className="h1Cal">{this.state.translations.calCompTitle}</h1>

                    <div className='calwrapper'>
                        <div className="leftside">
                            <div className="HeaderStrings">
                                <h4 className='h4cal'>{this.state.translations.calCompMsgPrior}. </h4>


                            </div>

                            <div className="LowerStrings">
                                {this.handleEAW()}
                                {this.handleUSw()}

                            </div>

                            <Form className="DateInput"  >

                                {this.handleDateSelected()}


                                <Button
                                    type='submit'
                                    color="green"
                                    onClick={this.handleCalClickBack}
                                    className="calbackbutton">
                                    <i class="left arrow icon"></i> {this.state.translations.buttonBackText}
                                </Button>
                                <Button
                                    type='submit'
                                    required
                                    color="green"
                                    onClick={this.handleNextClick}
                                    className="nextbtton">
                                    {this.state.translations.buttonNextText}
                                    <i class="right arrow icon">
                                    </i>
                                </Button>


                                {this.handelHelpButton()}
                                {this.userErrorMessage()}
                            </Form>



                        </div>

                        <div className="rightside">

                            <DayPicker
                                mode="single"
                                selected={this.state.selectedDay}
                                onSelect={(day) => this.setState({ selectedDay: day })}
                                numberOfMonths={2}
                                disabled={[
                                    { dayOfWeek: [0, 2, 3, 4, 5, 6] }, // disables all non-Mondays
                                    ...(this.state.disabledDates || []) // disables your 8-week window and invalid dates
                                ]}
                                month={this.state.month}
                                onMonthChange={this.handleMonthChange}
                                className={userRole === 'CORPORATE' ? 'CORP' : userRole === 'FIELD' ? 'FIELD' : 'PRO'}
                                locale={localeObj}
                            />

                            <div>
                                <p className='RedText'>
                                    {this.state.translations.calCompMsgNoMonday1}<br />
                                    {this.state.translations.calCompMsgNoMonday2}.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                {this.handleFooterSelection()}
            </div>

        );
    }
}
export default connect()(CalendarComp);
